import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  className?: string;
}

export function BackButton({ className = "" }: BackButtonProps) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      className={`flex items-center gap-1 hover:bg-primary/10 hover:text-primary ${className}`}
      onClick={handleGoBack}
    >
      <ArrowLeft className="h-4 w-4" />
      <span>Wróć</span>
    </Button>
  );
}